export const INSTANT_EMAIL_SECTION_TYPE = 'instantEmailFlag';
export const DAILY_DIGEST_TYPE = 'activityDigestEmailFlag';
export const EXECUTIVE_REPORT_TYPE = 'executiveReportFlag';
export const GLOBAL_SETTINGS_TYPE = 'globalSettingsFlag';
